import clsx from "clsx";

import type { BoxProps } from "@/ui/atoms/Box";
import Box from "@/ui/atoms/Box";

export type CardProps = BoxProps;

const testId = "Card";
const Card = (props: CardProps) => {
    const { sx, children, className, ...otherProps } = props;

    return (
        <Box
            data-testid={testId}
            className={clsx([testId, className])}
            sx={{
                borderTop: "8px solid var(--proda-navy-blue)",
                borderRadius: "4px",
                padding: "24px",
                boxShadow: "var(--shadow-default)",
                ...sx,
            }}
            {...otherProps}
        >
            {children}
        </Box>
    );
};

export default Card;
